import { ArrowDown, Orbit } from "lucide-react";
import { motion } from "framer-motion";
import { FirstVisitHero } from "@/components/today/FirstVisitHero";

const convergenceStart={opacity:0,y:18};const convergenceEnd={opacity:1,y:0};

export const PatternConvergence = ({ pattern, loading, onPause }) => {
  if (loading) return <section className="convergence-loading" data-testid="pattern-convergence-loading"><Orbit/><span>Reading today’s coordinates…</span></section>;
  if (!pattern) return <FirstVisitHero onPause={onPause}/>;
  return <motion.section className="convergence-brief" initial={convergenceStart} animate={convergenceEnd} data-testid="pattern-convergence-brief">
    <div className="convergence-copy"><p className="kicker">Your pattern · Today</p><h1 data-testid="convergence-heading">{pattern.title}</h1><p data-testid="convergence-summary">{pattern.summary}</p><a className="convergence-reading-link" href="#integrated-reading" data-testid="open-integrated-reading-link">See what this means for you <ArrowDown/></a></div>
  </motion.section>;
};